document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initFaq();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  els.forEach(function (el) { obs.observe(el); });
  setTimeout(function () {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
  }, 2500);
}

function initFaq() {
  var items = document.querySelectorAll('.mt-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open) {
        items.forEach(function (other) {
          if (other !== item) other.removeAttribute('open');
        });
      }
    });
  });
}
